import { RuleConsequenceCreateObjectAllOf } from '@innovatm/js-rule-editor/src/backend';
import { Box, FormControlLabel, FormHelperText, MenuItem, Select } from '@mui/material';
import { TypographyProps } from '@mui/material/Typography';
import { Field, FieldProps, useFormikContext } from 'formik';
import React, { memo, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { toast } from 'react-toastify';

import {
    ResourceManagerRule,
    RuleConsequenceCreateObject,
    TextOperand,
    useQueryGetGetResourcesByType,
} from '../../../backend';
import { errorToastConfig } from '../../../utils/utils';

export const ResourceNameField = memo(function ResourceNameField() {
    const { values } = useFormikContext<ResourceManagerRule>();
    const { data: resources } = useQueryGetGetResourcesByType(
        {
            type: values.resourceType,
            includeNonActive: true,
        },
        {
            select: response => {
                return {
                    ...response,
                    data: response.data.sort((a, b) => {
                        return a.name.localeCompare(b.name, undefined, { numeric: true });
                    }),
                };
            },
            notifyOnChangeProps: ['data', 'error'],
            onError: () => {
                toast(<FormattedMessage id={'resourcesForm.error.default'} />, errorToastConfig);
            },
        },
    );
    const error = useMemo(
        () =>
            !resources?.find(
                r =>
                    r.name ===
                    ((values.consequence as RuleConsequenceCreateObject).objectFields['resource'] as TextOperand).value,
            ),
        [resources, values.consequence],
    );

    return (
        <Field name="consequence.objectFields">
            {({
                field,
                form: { setFieldValue },
            }: FieldProps<RuleConsequenceCreateObjectAllOf['objectFields'], ResourceManagerRule>) => (
                <Box key={'resource'} mb={1}>
                    <FormControlLabel
                        componentsProps={{
                            typography: { minWidth: 250, textAlign: 'right', marginRight: 2 } as TypographyProps,
                        }}
                        labelPlacement={'start'}
                        label={'resource'}
                        control={
                            <div>
                                <Select
                                    id="select-type"
                                    onChange={e =>
                                        setFieldValue('consequence.objectFields', {
                                            ...field.value,
                                            resource: { type: 'TextOperand', value: e.target.value },
                                        })
                                    }
                                    value={(field.value['resource'] as TextOperand)?.value}
                                    error={error}
                                    sx={{ width: '174px' }}
                                >
                                    {resources?.map(resource => (
                                        <MenuItem sx={{ color: 'white' }} key={resource.name} value={resource.name}>
                                            {resource.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                                {error && <FormHelperText>Pick an existing resource.</FormHelperText>}
                            </div>
                        }
                    />
                </Box>
            )}
        </Field>
    );
});
